import { useEffect, useState } from "react";
import { sendMessageToWebview } from "../../services/native";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { useHistory } from "react-router-dom";
import { getMyMemberDetails } from "../../services/memberService";
import { setUserData } from "../../redux/member";
import NiceModal from "@ebay/nice-modal-react";
import {
  GAActions,
  GACategoryName,
  GAEventNames,
  GAUniqueEventIds,
  GenderType,
  PageContentText,
} from "../../helpers/Enums";
import { GET_PARAMS, GET_POPUPS } from "../../const/router";
import usePrepareLink from "../../hooks/usePrepareLink";
import { getApplicationPageContentText } from "../../services/appSettingService";
import Loader from "react-loader-spinner";
import { recordGaEvent } from "../../helpers/GoogleAnalytics";
import { PremiumOptionPurchase } from "../../typings/premium";

const PremiumOptions = () => {
  const [premiumSaleTitle, setPremiumSaleTitle] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [premiumOptions, setPremiumOptions] = useState<PremiumOptionPurchase[]>(
    []
  );

  let member = useSelector((state: RootState) => state.member);
  let history = useHistory();
  const dispatch = useDispatch();

  const helpWithPurchaseEvent = () => {
    recordGaEvent(
      GAEventNames.APP_ENGAGMENT,
      GACategoryName.PREMIUM_SCREEN,
      "telephone help button",
      "telephone help button",
      GAUniqueEventIds.APP_ACTIONS
    );
  };

  useEffect(() => {
    getPremiumTitleText();
    setWhatPlansToShow();
  }, []);

  const premiumPlanDetailslink = usePrepareLink({
    pushToQuery: {
      [GET_PARAMS.popup]: GET_POPUPS.popup.premiumPlanDetails,
    },
    keepOldQuery: true,
  });

  const setWhatPlansToShow = () => {
    let premiumOptionsDefault: PremiumOptionPurchase[] = [
      {
        price: "35₪ ש''ח לחודש",
        isLight: true,
        image: "assets/images/logo_sh_light.svg",
        discount: null,
        isChoosen: true,
        androidProductId: "premium_and_premium_light",
        appleProductId: "premium_light_ios",
        show: true,
        planName: "light",
      },
      {
        price: "98₪ ש''ח לחודש",
        isLight: false,
        image: "assets/images/logo_sh_premium.svg",
        discount: "30% הנחה",
        isChoosen: false,
        androidProductId: "one_month_renewable_sub",
        appleProductId: "one_month_renewable_sub_ios",
        show: true,
        planName: "premium",
      },
    ];

    if (member.isPremium) {
      if (member.subscriptionPlanId === 4) {
        //light plan
        premiumOptionsDefault[0].isChoosen = false;
        premiumOptionsDefault[0].show = false;
        premiumOptionsDefault[1].isChoosen = true;
        setPremiumOptions(premiumOptionsDefault);
      } else {
        setPremiumOptions(premiumOptionsDefault);
      }
    } else {
      setPremiumOptions(premiumOptionsDefault);
    }
  };

  //handle subscriptions purchase status notification made from native app
  useEffect(() => {
    const notifySubscriptionPurchase = async (isValid: boolean) => {
      if (isValid) {
        await updateMemberDetails();
        NiceModal.show("action_modal", {
          onNext: () => {
            NiceModal.hide("action_modal");
            history.replace(premiumPlanDetailslink);
          },
          headerTitle: "איזה כיף, יש לך מנוי פרימיום",
          contentTitle: "כל האפשרויות המתקדמות של שושק'ה פתוחות בפניך",
          primaryButtonText: "המשך",
          showCloseButton: false,
          showSeconderyButton: false,
        });
        recordGaEvent(
          GAEventNames.APP_PURCHASE,
          GACategoryName.PREMIUM_SERVICE,
          "step 4",
          "purchase pop up",
          GAUniqueEventIds.CLICKED_ON_UPGRADE_TO_PREMIUM
        );
      } else {
        NiceModal.show("action_modal", {
          onNext: () => {
            NiceModal.hide("action_modal");
          },
          headerTitle: "שגיאה לא צפויה",
          contentTitle: (
            <div>
              <p>קרתה שגיאה בתהליך ההרשמה למנוי הפרימיום</p>{" "}
              <p>
                לבירור אפשר לפנות ל <span>shoshke@motke.co.il</span>
              </p>
            </div>
          ),
          primaryButtonText: "הבנתי",
          showCloseButton: false,
          showSeconderyButton: false,
        });
      }
    };

    (window as any).notifySubscriptionPurchase = notifySubscriptionPurchase;

    return () => {
      delete (window as any).notifySubscriptionPurchase;
    };
  }, []);

  const updateMemberDetails = async () => {
    try {
      const { data } = await getMyMemberDetails(member.memberCode);
      dispatch(setUserData(data));
    } catch (e) {
      console.log(e);
    }
  };

  const getPremiumTitleText = async () => {
    try {
      const { data } = await getApplicationPageContentText(
        PageContentText.PREMIUM_SALE_TITLE_ID
      );
      setPremiumSaleTitle(data);
      setIsLoading(false);
    } catch (e) {
      setPremiumSaleTitle("כותרת עמוד");
    }
  };

  const updatePremiumOption = (index: number) => {
    setPremiumOptions((prevOptions) =>
      prevOptions.map((option, i) =>
        i === index
          ? { ...option, isChoosen: true }
          : { ...option, isChoosen: false }
      )
    );
  };

  const transferChoosenPlanToNative = () => {
    const plan = premiumOptions.find((x) => x.isChoosen);
    let planName: string = plan !== undefined ? plan.planName : "error";
    recordGaEvent(
      GAEventNames.APP_PURCHASE,
      GACategoryName.PREMIUM_SERVICE,
      "step 3",
      planName,
      GAUniqueEventIds.CLICKED_ON_UPGRADE_TO_PREMIUM
    );

    const token = localStorage.getItem("token");
    if (window.platform === "android") {
      sendMessageToWebview("start-store-paymnet", {
        token: token,
        productId: plan?.androidProductId,
        member: {
          name: member.nickName,
          email: member.email,
          memberCode: member.memberCode.toString(),
        },
      });
    } else {
      sendMessageToWebview("start-store-paymnet", {
        token: token,
        productId: plan?.appleProductId,
        member: {
          name: member.nickName,
          email: member.email,
          memberCode: member.memberCode.toString(),
        },
      });
    }
  };

  const handleBack = () => {
    history.replace("/myProfile?popup=premiumMessage");
  };

  const premiumOptionsComponent = () => {
    return (
      <>
        <a
          onClick={handleBack}
          href="#"
          className="meet_close prem w-inline-block"
        >
          <img src="assets/images/ic_back_white.svg" loading="lazy" alt="" />
        </a>
        <div className="content_sec full">
          <div className="content_block premium_opt">
            <div className="prem_options_group" style={{ minHeight: "680px" }}>
              <h1 className="center_title">חבילות פרימיום</h1>
              <h3 className="prem_opt_title">בחר/י את התוכנית המתאימה לך:</h3>
              <div className="prem_banner_block">
                <img
                  src="assets/images/prem_banner_pict.svg"
                  loading="lazy"
                  alt=""
                  className="prem_banner_pict mirror"
                />
                <img
                  src="assets/images/prem_banner_pict.svg"
                  loading="lazy"
                  alt=""
                  className="prem_banner_pict"
                />
                <div>מבצע לזמן מוגבל, שבוע ראשון חינם לנרשמים חדשים!</div>
              </div>
              <ul role="list" className="premium_opt_list w-list-unstyled">
                {premiumOptions.map((option, index) => {
                  if (option.show) {
                    return (
                      <li
                        className="premium_opt_item"
                        onClick={() => updatePremiumOption(index)}
                      >
                        <a
                          href="#"
                          className={
                            option.isChoosen
                              ? "premium_opt_link act w-inline-block"
                              : "premium_opt_link w-inline-block"
                          }
                        >
                          <div
                            className={
                              option.isLight
                                ? "premium_title_gr light"
                                : "premium_title_gr"
                            }
                          >
                            <img src={option.image} loading="lazy" alt="" />
                          </div>
                          <div className="premium_opt_line" />
                          <div className="premium_opt_info">
                            <div className="premium_opt_txt">
                              {option.price}
                            </div>
                            <div>מתחדש מידי חודש</div>
                          </div>
                          {option.discount && (
                            <div className="premium_opt_flah">
                              {option.discount}
                            </div>
                          )}
                        </a>
                      </li>
                    );
                  }
                })}
              </ul>
              <a
                onClick={helpWithPurchaseEvent}
                href="https://api.whatsapp.com/send/?phone=972533769023&text&type=phone_number&app_absent=0"
                target="_blank"
                className="skip_link block"
              >
                זקוקים לסיוע? כתבו לנו בווטסאפ
              </a>
              {/* <a onClick={helpWithPurchaseEvent} href="https://docs.google.com/forms/d/e/1FAIpQLSeyRWjsIw0lW8xtLW6mRGuLeB2pK1LDSEAUTw7bOL7Of6gv2Q/viewform" target='_blank' className="skip_link block">
                                לסיוע טלפוני ברכישה אפשר ללחוץ כאן
                            </a> */}
            </div>
          </div>
        </div>

        <div className="nav_sec full">
          <div className="content_block footer">
            <a
              href="#"
              onClick={transferChoosenPlanToNative}
              className="button_full premium_options w-button"
            >
              {member.genderId === GenderType.MALE ? "בחר" : "בחרי"}
            </a>
            <div className="button_info_txt">
              רכישת המנוי נעשית דרך חנות האפליקציות. המנוי מתחדש אוטומטית באותם
              התנאים בהתאם לתוכנית שנבחרה. אפשר לבטל את המנוי בכל שלב דרך החנות.
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      {isLoading ? (
        <div
          style={{
            height: "100%",
            margin: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader type="ThreeDots" color="#f47373" />
        </div>
      ) : (
        premiumOptionsComponent()
      )}
    </>
  );
};

export default PremiumOptions;
